import script from "./Logs.vue?vue&type=script&lang=ts&setup=true"
export * from "./Logs.vue?vue&type=script&lang=ts&setup=true"

import "./Logs.vue?vue&type=style&index=0&id=ef364988&lang=less"

const __exports__ = script;

export default __exports__